import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { API_BASE_URL } from './api-base';

@Injectable({
  providedIn: 'root'
})
export class EnvironmentService {

  private apiUrl = `${API_BASE_URL}/environments`;

  constructor(private http: HttpClient) {}

  createEnvironment(payload: FormData): Observable<any> {
    return this.http.post(this.apiUrl, payload);
  }

  getEnvironments(): Observable<any[]> {
    return this.http.get<any[]>(this.apiUrl);
  }

  getTenantModules(tenantId: number): Observable<any[]> {
    return this.http.get<any[]>(`${API_BASE_URL}/modules/tenant`, { params: { tenant_id: tenantId } });
  }

  deleteEnvironment(id: number): Observable<any> {
    return this.http.delete(`${this.apiUrl}/${id}`);
  }

  updateEnvironment(id: number, payload: FormData): Observable<any> {
    return this.http.put(`${this.apiUrl}/${id}`, payload);
  }

  resendMasterEmail(id: number): Observable<any> {
    return this.http.post(`${this.apiUrl}/${id}/resend-master`, {});
  }
}
